<div class="main-content">
    <div class="container-fluid">
        <!-- Estado de carga -->
        <div *ngIf="!loading" class="alert alert-info">
            Estado: Datos cargados
            <br>
            Número de registros: {{data?.length || 0}}
        </div>

        <div class="row">
            <div class="col-8">
                <h3 class="d-inline-block">Servicios</h3>
            </div>
            <div class="col-4 text-right">
                <button class="btn btn-success" (click)="addNew()">
                    <i class="material-icons">add</i>
                    <span>AGREGAR</span>
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <!-- Estado de carga -->
                        <div *ngIf="loading" class="text-center p-3">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Cargando...</span>
                            </div>
                        </div>

                        <!-- Tabla de datos -->
                        <div class="table-responsive" *ngIf="!loading && data && data.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre</th>
                                        <th>Estado</th>
                                        <th>Fecha Creación</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data; let i = index" [ngClass]="{
                                        'table-success': i % 8 === 0,
                                        'table-warning': i % 8 === 2,
                                        'table-info': i % 8 === 4,
                                        'table-danger': i % 8 === 6
                                    }">
                                        <td>{{item._id}}</td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.status ? 'Activo' : 'Inactivo'}}</td>
                                        <td>{{item.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>
                                        <td>
                                            <button class="btn btn-danger btn-link btn-sm" (click)="deleteData(item._id)">
                                                <i class="material-icons">delete</i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Mensaje sin datos -->
                        <div *ngIf="!loading && (!data || data.length === 0)" class="alert alert-warning">
                            No hay datos disponibles
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
